import { Suspense, lazy } from 'react';
import { Navigate, useRoutes, useLocation, useParams } from 'react-router-dom';

// layouts
import Marketing from 'src/pages/dashboard/Marketing';
// import ChatPage from 'src/pages/chat/ChatPage';

import LoadingScreen from '../components/LoadingScreen';
import AuthGuard from '../guards/AuthGuard';
import GuestGuard from '../guards/GuestGuard';
//import DashboardLayout from '../layouts/dashboard';
import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
import MainLayout from '../layouts/main';
import Relatorios from 'src/pages/dashboard/Relatorios';
import RelatorioForcaVendas from 'src/pages/dashboard/Relatorios/RelatorioForcaVendas1';
import Gerencia from 'src/pages/dashboard/Gerencia';
import ChamadosPage from 'src/pages/dashboard/Chamados';
import InicioPage from 'src/pages/dashboard/Inicio';
import ChamadosChat from 'src/pages/dashboard/Chamados/ChamadosChat';
import MeusChamados from 'src/pages/dashboard/Chamados/MeusChamados';
import RelatorioForcaVendasClientes from 'src/pages/dashboard/Relatorios/RelatorioForcaVendasClientes';
import SupervisaoLista from 'src/pages/dashboard/Supervisao/SupervisaoLista';
import RelatorioChamados from 'src/pages/dashboard/Relatorios/RelatorioChamados';

import Chat from 'src/pages/chats/Chat';
import ChatsArquivadas from 'src/pages/chats/ChatsArquivadas';
import Contatos from 'src/pages/chats/Contatos';
import Negocios from 'src/pages/dashboard/Negocios/Negocios';
import RelatorioListaAvaliacoes from 'src/pages/dashboard/Relatorios/RelatorioListaAvaliacoes';
import RelatorioAnalitcoNegocios from 'src/pages/dashboard/Relatorios/RelatorioAnalitcoNegocios';
import Configuracoes from 'src/pages/dashboard/Configuracoes';
import Conta from 'src/pages/dashboard/Conta';
import Suspend from 'src/pages/Suspend';
import { VendasPage } from 'src/pages/dashboard/Vendas';
import AiAnaliseSentimento from 'src/pages/dashboard/AiAnaliseSentimento/AiAnaliseSentimento';
import ChatInterno from 'src/pages/chats/ChatInterno';
import Automacoes from 'src/pages/dashboard/Automacoes/Automacoes';
import Calendario from 'src/pages/dashboard/Calendario';
import Automacao from 'src/pages/dashboard/Automacoes/Automacao';
import Workflow from 'src/pages/dashboard/Automacoes/Workflow';
import SessionExpire from 'src/pages/authentication/SessionExpire';
import FormulariosPublicos from 'src/pages/dashboard/Formularios';
import FormBuilder from 'src/pages/dashboard/Formularios/Builder';
import ChamadosCaixaBuilder from 'src/pages/dashboard/Configuracoes/ChamadosCaixaBuilder';
import Tarefas from 'src/pages/dashboard/Tarefas';
import Propostas from 'src/pages/dashboard/Propostas';
import PropostaEditor from 'src/pages/dashboard/Propostas/PropostaEditor';
import OrcamentoEditor from 'src/pages/dashboard/Propostas/orcamento/OrcamentoEditor';
import ModeloEditor from 'src/pages/dashboard/Propostas/ModeloEditor';
import ChatLayout from '../layouts/chats';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  const { pathname } = useLocation();
  const isDashboard = pathname.includes('/dashboard');

  return (
    <Suspense
      fallback={
        <LoadingScreen
          sx={{
            ...(!isDashboard && {
              top: 0,
              left: 0,
              width: 1,
              zIndex: 9999,
              position: 'fixed'
            })
          }}
        />
      }
    >
      <Component {...props} />
    </Suspense>
  );
};

function RedirectMarketingAgendamentos() {
  return <Navigate to="/dashboard/marketing/agendamentos" replace />;
}

function RedirectMarketingCampanhas() {
  return <Navigate to="/dashboard/marketing/campanhas" replace />;
}

function RedirectMarketingCampanhaDetalhes() {
  const { campanhaId } = useParams();
  return <Navigate to={`/dashboard/marketing/campanhas/${campanhaId}`} replace />;
}

export default function Router() {
  return useRoutes([
    {
      path: 'auth',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              {/* <Login /> */}
            </GuestGuard>
          )
        },
        { path: 'login-unprotected', element: <Login /> },
        { path: 'register-unprotected', element: <Register /> },
        { path: 'reset-password', element: <ResetPassword /> },
        { path: 'verify', element: <VerifyCode /> },
        { path: 'suspend', element: <Suspend /> },
        { path: 'callback', element: <Callback /> },

      ]
    },

    // Dashboard Routes
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          <ChatLayout />
        </AuthGuard>
      ),
      children: [
        { path: '', element: <Navigate to="home" replace /> },
        { path: 'home', element: <Painel /> },
        { path: 'inicio', element: <InicioPage /> },
        { path: 'supervisao/lista', element: <SupervisaoLista /> },
        { path: 'ai/analises', element: <AiAnaliseSentimento /> },
        { path: 'relatorios', element: <Relatorios /> },
        { path: 'negocios', element: <Negocios /> },
        { path: 'gerencia', element: <Gerencia /> },
        { path: 'automacoes/workflow/:id', element: <Workflow /> },
        { path: 'automacoes/:id', element: <Automacao /> },
        { path: 'contatos', element: <Contatos /> },
        { path: 'vendas', element: <VendasPage /> },
        { path: 'automacoes', element: <Automacoes /> },
        { path: 'chamados', element: <ChamadosPage /> },
        { path: 'meus-chamados', element: <MeusChamados /> },
        { path: 'respostas-rapidas', element: <MensagensRapidas /> },
        { path: 'relatorios/forca-vendas', element: <RelatorioForcaVendas /> },
        { path: 'relatorios/clientes-forca-vendas', element: <RelatorioForcaVendasClientes /> },
        { path: 'relatorios/chamados', element: <RelatorioChamados /> },
        { path: 'relatorios/chats-avaliacoes', element: <RelatorioListaAvaliacoes /> },
        { path: 'relatorios/negocios', element: <RelatorioAnalitcoNegocios /> },
        { path: 'campanhas', element: <RedirectMarketingCampanhas /> },
        { path: 'campanhas/:campanhaId', element: <RedirectMarketingCampanhaDetalhes /> },
        { path: 'calendar', element: <Calendar /> },
        { path: 'calendario', element: <Calendario /> },
        { path: 'configuracoes/:label', element: <Configuracoes /> },
        { path: 'conta/consumo/conversas', element: <Conta /> },
        { path: 'conta/:label', element: <Conta /> },
        { path: 'marketing/:label', element: <Marketing /> },
        { path: 'marketing/campanhas/:campanhaId', element: <Marketing /> },
        // Detalhe/criacao de publicacao: aponta para o proprio shell Marketing
        // para preservar a sidebar de marketing. 4 segmentos, entao nunca
        // colide com marketing/:label (rota folha de 3).
        { path: 'marketing/publicacoes/:postId', element: <Marketing /> },
        { path: 'marketing/anuncios/:adId', element: <Marketing /> },
        { path: 'tickets', element: <TicketsPage /> },
        { path: 'chamados-chat', element: <ChamadosChat /> },
        { path: 'chatbots/builder/:id', element: <ChatbotBuilder /> },
        { path: 'configuracoes/chamados-config-builder/:id', element: <ChamadosCaixaBuilder /> },
        { path: 'formularios', element: <FormulariosPublicos /> },
        { path: 'formularios/builder/new', element: <FormBuilder /> },
        { path: 'formularios/builder/:id', element: <FormBuilder /> },
        { path: 'tarefas', element: <Tarefas /> },
        { path: 'propostas', element: <Propostas /> },
        { path: 'propostas/nova', element: <PropostaEditor /> },
        { path: 'propostas/:id/editar', element: <PropostaEditor /> },
        { path: 'propostas/orcamentos/novo', element: <OrcamentoEditor /> },
        { path: 'propostas/orcamentos/:id/editar', element: <OrcamentoEditor /> },
        { path: 'propostas/modelos/novo', element: <ModeloEditor /> },
        { path: 'propostas/modelos/:id/editar', element: <ModeloEditor /> },
        { path: 'painel-ia', element: <PainelIA /> }
      ]
    },

    // Chat Routes
    {
      path: 'chats',
      element: (
        <AuthGuard>
          <ChatLayout />
        </AuthGuard>
      ),
      children: [
        { path: '', element: <Navigate to="chat" replace /> },
        {
          path: 'chat',
          children: [
            { path: '', element: <Chat /> },
            { path: 'new', element: <Chat /> },
            { path: ':conversationKey', element: <Chat /> }
          ]
        },

        {
          path: 'arquivadas',
          children: [
            { path: '', element: <ChatsArquivadas /> }
          ]
        },
        {
          path: 'perfil',
          children: [
            { path: '', element: <Perfil /> }
          ]
        },
        {
          path: 'agendamentos',
          element: <RedirectMarketingAgendamentos />
        },
        {
          path: 'interno',
          children: [
            { path: '', element: <ChatInterno /> },
            { path: 'new', element: <ChatInterno /> },
            { path: ':conversationKey', element: <ChatInterno /> }
          ]
        }
      ]
    },

    // Main Routes
    {
      path: '*',
      element: <LogoOnlyLayout />,
      children: [
        { path: '500', element: <Page500 /> },
        {
          path: 'expired',
          element: <SessionExpire />
        }
      ]
    },

    {
      path: '/',
      element: <MainLayout />,
      children: [
        { path: '', element: <Navigate to="chats/chat" replace /> },
      ]
    },
    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
}

// IMPORT COMPONENTS

// Authentication
const Login = Loadable(lazy(() => import('../pages/authentication/Login')));
const Register = Loadable(lazy(() => import('../pages/authentication/Register')));
const ResetPassword = Loadable(lazy(() => import('../pages/authentication/ResetPassword')));
const VerifyCode = Loadable(lazy(() => import('../pages/authentication/VerifyCode')));
const Callback = Loadable(lazy(() => import('../pages/authentication/Callback')));
// Dashboard
const Painel = Loadable(lazy(() => import('../pages/dashboard/Painel/index')));
//const Chat = Loadable(lazy(() => import('../pages/chats/Chat')));
const Staff = Loadable(lazy(() => import('../pages/chats/Staff')));
const ChatKanban = Loadable(lazy(() => import('../pages/chats/ChatKanban')));
const Perfil = Loadable(lazy(() => import('../pages/dashboard/Perfil/Perfil')));
const MensagensRapidas = Loadable(lazy(() => import('../pages/dashboard/MensagensRapidas')));
const Calendar = Loadable(lazy(() => import('../pages/dashboard/Calendar')));

// const Configuracoes = Loadable(lazy(() => import('../pages/dashboard/Configuracoes')));

const Page500 = Loadable(lazy(() => import('../pages/Page500')));
const TicketsPage = Loadable(lazy(() => import('../pages/dashboard/Tickets')));
const ChatbotBuilder = Loadable(lazy(() => import('../pages/dashboard/Chatbots/ChatbotBuilder')));
const PainelIA = Loadable(lazy(() => import('../pages/dashboard/PainelIA/index')));
